import React, { Fragment, Component, useEffect } from 'react';
import { Flex, Text, Card, Heading, Box, Button } from 'rebass';
import styled from 'styled-components';
import SpinLoader from '../../components/SpinLoader';
import { GET_CLINICAL_PROVIDERS_DOCTOR, SEND_KLAVIYO_STATUS, CREATE_BRIDGE_SERVICE_ELIGIBILITY } from '../../graphql';
import { Mutation, Query, withApollo } from 'react-apollo';
import CalendarGrid from './calendarGrid';
import { withWizard } from 'react-albus';
import ReadMore from '../../components/readMore/readmore';
import withSession from '../../lib/withSession';
import { objectHas } from '../../utils/helpers';
import moment from 'moment';
import StarRatings from '../../components/ratingStar/star-rating';
import ScrollAnimation from 'react-animate-on-scroll';
import telemedicine from '../../static/telemedicine.png';
import thyroid from '../../static/thyroid.png';
import iconBackgroundShape from '../../static/iconBackgroundShape.png';
import character from '../../static/character.png';
import ChatWithUs from './components/chatWithUs/chatWithUs';
import PractitionerTag from '../../components/PractitionerTag';
import ConfirmModal from '../../components/ConfirmModal';
import TimeDoesntWorkModalInner from './components/timeDoesntWork/timeDoesntWorkModalInner';
import { isMobile } from 'react-device-detect';
import InnerDetails from './InnerDetails';
import AddToWaitlistModalInner from '../scheduleDoctor/components/addToWaitlist/AddToWaitlistModalInner';

const ListContainer = styled(Flex)`
  border-right: 1px solid #ccc;
  width: 100%;
  /* background: #fdf5f2; //#f8f9fa; */
  height: 100%;
  max-width: 350px;
  min-width: 300px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  display: block;
  &.selected {
    display: none;
  }

  @media screen and (min-width: 52em) {
    width: 30%;
    overflow-y: auto;
    /* display: flex; */
    &.selected {
      display: flex;
    }
  }

  @media screen and (max-width: 52em) {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
  }
`;

const ClinicalFlex = styled(Flex)`
  display: block;

  @media screen and (min-width: 52em) {
    display: flex;
    overflow-y: hidden;
    max-height: calc(100vh - 80px);
  }
`;

const DetailContainer = styled(Flex)`
  display: none;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  &.selected {
    display: flex;
  }

  @media screen and (min-width: 52em) {
    display: flex;
  }
`;

const Inner = styled(Flex)`
  max-width: 650px;
`;

const NavLink = styled.div`
  text-decoration: none;
  color: #000;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 100px;
  transition: all 300ms ease;
  background: white;
  position: relative;
  cursor: pointer;
  &.active {
    background: rgba(180, 205, 244, 0.5);
  }
  &:hover {
    background: rgba(180, 205, 244, 0.5);
  }
`;

const NoNavLink = styled.div`
  text-decoration: none;
  color: #000;
  display: flex;
  align-items: center;
  background: transparent;
  width: 100%;
  min-height: 50px;
  transition: all 300ms ease;
`;

const Section = styled.div`
  color: #000;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 60px;
  transition: all 300ms ease;
  &.active {
    background: rgba(180, 205, 244, 0.5);
  }
`;

const ListItem = styled(Flex)`
  border-bottom: 1px solid #ccc;
  position: relative;
`;

const Avatar = styled(Flex)`
  width: 80px;
  height: 80px;
  background: #fff;
  border-radius: 50%;
  border: 1px solid #ccc;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  &.small {
    width: 40px;
    height: 40px;
    & > img {
      width: 40px;
    }
  }
  @media screen and (min-width: 52em) {
    &.small {
      width: 60px;
      height: 60px;
      & > img {
        width: 60px;
      }
    }
  }
`;

const Container = styled(Box)`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding-top: 48px;
`;

const InnerView = ({ run }) => {
  useEffect(() => {
    console.log('CSE in ue');
    run();
  }, []);
  return (
    <Flex>
      <Button>Continue</Button>
    </Flex>
  );
};

const CreateServiceEligibility = (props) => {
  const { slotId, policyIds, state, isNewPatient, onContinue, client } = props;
  useEffect(() => {
    console.log('CSE ue');

    const run = async () => {
      const result = await client.mutate({
        mutation: CREATE_BRIDGE_SERVICE_ELIGIBILITY,
        variables: {
          slotId,
          policyIds,
          state,
          isNewPatient,
        },
      });

      if (result && result.data &&result.data.createBridgeServiceEligibility && result.data.createBridgeServiceEligibility.id) {
        onContinue(result.data.createBridgeServiceEligibility);
      } else {
        console.log(result);
      }
    };

    run();
  }, []);
  return (
    <React.Fragment>
      <Flex flex={1} justifyContent="center" alignItems="center" flexDirection={'column'} mt={4}>
        <SpinLoader />
        <Text textAlign="center" mt={4} mb={4} fontSize="18px">
          Retrieving information...
        </Text>
      </Flex>
    </React.Fragment>
  );
  // return (
  //   <Mutation
  //     mutation={CREATE_BRIDGE_SERVICE_ELIGIBILITY}
  //     variables={{
  //       slotId,
  //       policyIds,
  //       state,
  //       isNewPatient,
  //     }}
  //     onCompleted={(e) => {
  //   console.log('CSE onCompleted')
  //       if(e && e.createBridgeServiceEligibility && e.createBridgeServiceEligibility.id){
  //       onContinue(e.createBridgeServiceEligibility)
  //     }else{
  //       console.log(e)
  //     }
  //     }}
  //   >
  //     {(mutate, { loading, data }) => {
  //       // console.log({ data });
  //       if (loading) {
  //         return (
  //           <React.Fragment>
  //             <Flex flex={1} justifyContent="center" alignItems="center" flexDirection={'column'} mt={4}>
  //               <SpinLoader />
  //               <Text textAlign="center" mt={4} mb={4} fontSize="18px">
  //                 Retrieving information...
  //               </Text>
  //             </Flex>
  //           </React.Fragment>
  //         );
  //       }

  //       return <InnerView run={mutate} />;
  //     }}
  //   </Mutation>
  // );
};

export const CreateBridgeServiceEligibility = withWizard(withApollo(CreateServiceEligibility));
